import { render, staticRenderFns } from "./editWorkPoints.vue?vue&type=template&id=211b87ed&scoped=true&lang=html&"
import script from "./editWorkPoints.vue?vue&type=script&lang=js&"
export * from "./editWorkPoints.vue?vue&type=script&lang=js&"
import style0 from "./editWorkPoints.vue?vue&type=style&index=0&id=211b87ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211b87ed",
  null
  
)

export default component.exports